export default function createScript(scriptId: string, src: string) {
  const script = document.createElement('script');

  script.setAttribute('id', scriptId);
  script.setAttribute('charset', 'UTF-8');
  script.setAttribute('src', src);

  return script;
}
